import React from 'react';
import CloudMonitorPage from './CloudMonitorPage';

export default function CloudMonitorAWS() {
  return <CloudMonitorPage provider="aws" />;
}
